import PayrollWelfareCreateComponents from "../components/WelfareCreate";
import useWelfare from "../hooks/useWelfare";

const PayrollWelfareCreate = () => {
  const useWelfareProps = useWelfare();
  return <PayrollWelfareCreateComponents {...useWelfareProps} />;
};

export default PayrollWelfareCreate;
